/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsTriggerReprocessOlafReprocessMutationRequest, AuditReportsTriggerReprocessOlafReprocessMutationResponse, AuditReportsTriggerReprocessOlafReprocess401, AuditReportsTriggerReprocessOlafReprocess403 } from "../models/AuditReportsTriggerReprocessOlafReprocess";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsTriggerReprocessOlafReprocess } from "../axios/auditReportsTriggerReprocessOlafReprocess";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsTriggerReprocessOlafReprocessMutationKey = () => [{ url: '/audit-reports/v1/olaf/reprocess' }] as const

export type AuditReportsTriggerReprocessOlafReprocessMutationKey = ReturnType<typeof auditReportsTriggerReprocessOlafReprocessMutationKey>

export function auditReportsTriggerReprocessOlafReprocessMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AuditReportsTriggerReprocessOlafReprocessMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = auditReportsTriggerReprocessOlafReprocessMutationKey()
        return mutationOptions<AuditReportsTriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessOlafReprocess401 | AuditReportsTriggerReprocessOlafReprocess403>, {data: AuditReportsTriggerReprocessOlafReprocessMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return auditReportsTriggerReprocessOlafReprocess(data, config)
          },
        })

}

/**
 * @summary Trigger standalone OLAF reprocess
 * {@link /audit-reports/v1/olaf/reprocess}
 */
export function useAuditReportsTriggerReprocessOlafReprocess<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsTriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessOlafReprocess401 | AuditReportsTriggerReprocessOlafReprocess403>, {data: AuditReportsTriggerReprocessOlafReprocessMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AuditReportsTriggerReprocessOlafReprocessMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsTriggerReprocessOlafReprocessMutationKey()

          const baseOptions = auditReportsTriggerReprocessOlafReprocessMutationOptions(config) as UseMutationOptions<AuditReportsTriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessOlafReprocess401 | AuditReportsTriggerReprocessOlafReprocess403>, {data: AuditReportsTriggerReprocessOlafReprocessMutationRequest}, TContext>
          

          return useMutation<AuditReportsTriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessOlafReprocess401 | AuditReportsTriggerReprocessOlafReprocess403>, {data: AuditReportsTriggerReprocessOlafReprocessMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsTriggerReprocessOlafReprocessMutationResponse, ResponseErrorConfig<AuditReportsTriggerReprocessOlafReprocess401 | AuditReportsTriggerReprocessOlafReprocess403>, {data: AuditReportsTriggerReprocessOlafReprocessMutationRequest}, TContext>
      
}